import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function MobileNumber({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Mobile number")}</legend>
      <input
        onChange={onChange}
        value={searchObject.mobileNumber || ""}
        name="mobileNumber"
        className="form-control fontsize-legend"
      />
    </div>
  );
}
